"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Th = exports.THead = exports.TFooter = exports.TBody = exports.SvgSortBy = exports.Path = exports.LoadingWrapper = exports.LoadingRow = exports.Custom = void 0;

var _designSystem = require("@superlogica/design-system");

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Custom = _styledComponents.default.div.withConfig({
  componentId: "sc-2uwqdl-0"
})(["display:flex;vertical-align:middle;", ""], function (_ref) {
  var align = _ref.align;
  return "\n    justify-content: ".concat(align, ";\n  ");
});

exports.Custom = Custom;

var LoadingRow = _styledComponents.default.div.withConfig({
  componentId: "sc-2uwqdl-1"
})(["padding-top:", "px;padding-bottom:", "px;padding-right:", "px;padding-left:", "px;border-bottom:", "px solid ", ";&:first-child{border-top:", "px solid ", ";}&:last-child{border-bottom:none;}"], _elements.boxPadding.squish.xs.top, _elements.boxPadding.squish.xs.bottom, _elements.boxPadding.squish.sm.right, _elements.boxPadding.squish.sm.left, _tokens.borderWidth.xs, _tokens.colors.neutral100, _tokens.borderWidth.xs, _tokens.colors.neutral100);

exports.LoadingRow = LoadingRow;

var LoadingWrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-2uwqdl-2"
})(["width:100%;position:relative;"]);

exports.LoadingWrapper = LoadingWrapper;

var THead = _styledComponents.default.thead.withConfig({
  componentId: "sc-2uwqdl-3"
})(["th{white-space:nowrap;padding-top:", "px;padding-bottom:", "px;padding-right:", "px;padding-left:", "px;}"], _elements.boxPadding.squish.xs.top, _elements.boxPadding.squish.xs.bottom, _elements.boxPadding.squish.sm.right, _elements.boxPadding.squish.sm.left);

exports.THead = THead;

var Th = _styledComponents.default.th.withConfig({
  componentId: "sc-2uwqdl-4"
})(["position:relative;"]);

exports.Th = Th;

var TBody = _styledComponents.default.tbody.withConfig({
  componentId: "sc-2uwqdl-5"
})(["background-color:", ";td{transition:0.2s all linear;padding-top:", "px;padding-bottom:", "px;padding-right:", "px;padding-left:", "px;}", ""], _tokens.colors.neutral0, _elements.boxPadding.squish.xs.top, _elements.boxPadding.squish.xs.bottom, _elements.boxPadding.squish.sm.right, _elements.boxPadding.squish.sm.left, function (_ref2) {
  var theme = _ref2.theme;
  return "\n  td {\n    a {\n      color: ".concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n    }\n  }\n  tr {\n    cursor: pointer;\n    border-bottom: ").concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors.neutral100, ";\n    &:first-child {\n      border-top: ").concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors.neutral100, ";\n    }\n    &:last-child {\n      border-bottom: none;\n    }\n    &:hover {\n      td {\n        background: ").concat(_tokens.colors[theme.colors.neutral50.color + theme.colors.neutral50.scale], ";\n      }\n    }\n  }\n  ");
});

exports.TBody = TBody;
var TFooter = (0, _styledComponents.default)(_designSystem.Box).attrs({
  paddingType: 'squish',
  paddingSize: 'sm'
}).withConfig({
  componentId: "sc-2uwqdl-6"
})(["border-top:1px solid ", ";"], _tokens.colors.neutral100);
exports.TFooter = TFooter;

var Wrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-2uwqdl-7"
})(["overflow-x:auto;padding-left:", "px;padding-right:", "px;"], _tokens.spacing.vertical.sm, _tokens.spacing.vertical.sm);

exports.Wrapper = Wrapper;

var SvgSortBy = _styledComponents.default.svg.withConfig({
  componentId: "sc-2uwqdl-8"
})(["position:absolute;right:0;top:8px;"]);

exports.SvgSortBy = SvgSortBy;

var Path = _styledComponents.default.path.withConfig({
  componentId: "sc-2uwqdl-9"
})(["", ""], function (_ref3) {
  var color = _ref3.color;
  return "\n    fill: ".concat(color, ";\n  ");
});

exports.Path = Path;